{
    "name": "Fresno Pepper",
    "binomial_name": "Capsicum annuum 'Fresno Chili'",
    "common_names": [
        "fresno pepper",
        "fresno chili"
    ],
    "description": "The Fresno Chili pepper is a Capiscum annuum cultivar created by Clarence Brown Hamlin in 1952. The plant produces 5-7cm long conical fruit that grow pointed upwards. As they mature, they turn from green to orange to red and the fruit droops downwards. The peppers have a Scoville rating of 2,500-10,000 units and can be substituted for jalape\u00f1o and serrano peppers in sauces, salsas, chutneys, and stews. They have a more complex flavor than jalape\u00f1os and mature faster. Fresno Chilis do not dry well and are best used fresh. Young green peppers are less hot than fully mature red ones.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Direct seed indoors, transplant seedlings outside after hardening off",
    "spread": 0,
    "row_spacing": 45,
    "height": 75,
    "growing_degree_days": 0,
    "companions": [],
    "image": "",
    "icon": "/crops/icons/fresno-pepper.avif"
}